// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entity-table{padding-bottom:3vh}.entity-table .editColumn{text-align:right !important;white-space:nowrap}\n", ""]);
// Exports
module.exports = exports;
